import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPembelian = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [kodeStok, setKodeStok] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [stoks, setStoks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPembelianPerHaris, setLapPembelianPerHaris] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  let stokOptions = stoks.map((stok) => ({
    label: `${stok.kodeStok} - ${stok.namaStok}`,
  }));

  useEffect(() => {
    getStokData();
  }, []);

  const getStokData = async () => {
    const response = await axios.post(`${tempUrl}/stoks`, {
      _id: user.id,
      token: user.token,
    });
    setStoks(response.data);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPembelian",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let laporanPembelianPerStok = await axios.post(
        `${tempUrl}/laporanPembelian`,
        {
          dariTanggal,
          sampaiTanggal,
          kodeStok: kodeStok.split(" ", 1)[0],
          kodeCabang,
          _id: user.id,
          token: user.token,
        }
      );
      setLapPembelianPerHaris(laporanPembelianPerStok.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  let tempTotalQuantity = 0;
  let tempTotalTotalPembelianChild = 0;

  Object.values(lapPembelianPerHaris).map((user, index) => {
    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={8}
        >
          Stok : {user[0].stok.kodeStok} ({user[0].stok.namaStok})
        </td>
      </tr>
    );

    let tempSubtotalQuantity = 0;
    let tempSubtotalTotalPembelianChild = 0;

    user.map((row, index) => {
      tempSubtotalQuantity += row.quantity;
      tempSubtotalTotalPembelianChild += row.totalPembelianChild;

      tempTotalQuantity += row.quantity;
      tempTotalTotalPembelianChild += row.totalPembelianChild;

      list.push(
        <tr key={row.id ?? index} style={tableText}>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {index + 1}
          </td>

          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row?.pembelian?.noNotaPembelian}
          </td>

          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row?.pembelian?.tglPembelian
              ? formatDate(row.pembelian.tglPembelian)
              : ""}
          </td>

          <td style={textNumberRight}>
            {isCetakExcel === false
              ? Number(row.quantity ?? 0).toLocaleString("en-EN")
              : row.quantity ?? 0}
          </td>

          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {row?.stok?.satuanKecilStok ?? ""}
          </td>

          <td style={textNumberRight}>
            {isCetakExcel === false
              ? Number(row.hargaSatuan ?? 0).toLocaleString("en-EN")
              : row.hargaSatuan ?? 0}
          </td>

          <td style={textNumberRight}>
            {isCetakExcel === false
              ? Number(
                  (row.discount1 + row.discount2) * row.quantity ?? 0
                ).toLocaleString("en-EN")
              : (row.discount1 + row.discount2) * row.quantity ?? 0}
          </td>

          <td style={textNumberRight}>
            {isCetakExcel === false
              ? Number(row.totalPembelianChild ?? 0).toLocaleString("en-EN")
              : row.totalPembelianChild ?? 0}
          </td>
        </tr>
      );
    });

    list.push(
      <tr key="subtotal" style={tableText}>
        <td
          style={{
            paddingLeft: "15px",
            border: "1px solid black",
            fontWeight: "bold",
          }}
          colSpan={3}
        >
          Subtotal Stok : {user[0].stok.kodeStok} ({user[0].stok.namaStok})
        </td>

        <td style={textNumberRight}>
          {isCetakExcel === false
            ? Number(tempSubtotalQuantity ?? 0).toLocaleString("en-EN")
            : tempSubtotalQuantity ?? 0}
        </td>
        <td colSpan={3}></td>

        <td style={textNumberRight}>
          {isCetakExcel === false
            ? Number(tempSubtotalTotalPembelianChild ?? 0).toLocaleString(
                "en-EN"
              )
            : tempSubtotalTotalPembelianChild ?? 0}
        </td>
      </tr>
    );
  });

  list.push(
    <tr key="subtotal" style={tableText}>
      <td
        style={{
          paddingLeft: "15px",
          border: "1px solid black",
          fontWeight: "bold",
        }}
        colSpan={3}
      >
        Total :
      </td>

      <td style={textNumberRight}>
        {isCetakExcel === false
          ? Number(tempTotalQuantity ?? 0).toLocaleString("en-EN")
          : tempTotalQuantity ?? 0}
      </td>
      <td colSpan={3}></td>

      <td style={textNumberRight}>
        {isCetakExcel === false
          ? Number(tempTotalTotalPembelianChild ?? 0).toLocaleString("en-EN")
          : tempTotalTotalPembelianChild ?? 0}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPembelian",
    sheet: "LaporanPembelian",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Pembelian</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Stok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={stokOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && kodeStok.length === 0 && true}
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeStok(value.label);
                      } else {
                        setKodeStok("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeStok}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Pembelian
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Stok : {kodeStok ? kodeStok : "SEMUA"}</p>
          <p>Cabang : {namaCabang}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>NO.</th>
                <th style={{ border: "1px solid black" }}>NO. NOTA</th>
                <th style={{ border: "1px solid black" }}>TANGGAL</th>
                <th style={{ border: "1px solid black" }}>QTI</th>
                <th style={{ border: "1px solid black" }}>SAT.</th>
                <th style={{ border: "1px solid black" }}>HARGA</th>
                <th style={{ border: "1px solid black" }}>POTONGAN</th>
                <th style={{ border: "1px solid black" }}>TOTAL</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPembelian;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
